import "@/styles/globals.css";
import type { AppProps } from "next/app";
import { RecoilRoot } from "recoil";
import Head from 'next/head';

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>DNF雾隐之地：雾神攻坚战预习小游戏 - 雾神攻坚战完全攻略手册 - COLG玩家社区 - 从小白到团长！</title>
        <meta name="keywords" content="dnf雾神,dnf雾神团本,dnf雾神攻坚战,dnf雾神raid,dnf雾神攻略,dnf雾神团本攻略,dnf雾神攻坚战预习小游戏colg雾神机制模拟器,colg团本模拟器,colg雾神,colg,colg社区,dnf,地下城与勇士,dnf官网" />
        <meta name="description" content="DNF雾神攻坚战上线，地下城与勇士迎来全新的雾神raid玩法，COLG玩家社区为大家提供最全的雾神团本攻略，包括图文教程、视频教程等，同时也精心准备了一些雾神团本相关的考题，方便各位快速学会雾神各个机制。最新最全的雾神攻坚战团本攻略更多精彩内容尽在COLG玩家社区。" />
        
      </Head>
      <RecoilRoot>
        <Component {...pageProps} />
      </RecoilRoot>
    </>

  )
}
